import styles from "./MService.module.scss"

import serviceBg2 from "../assets/images/service_bg2.png"
import { useLoaderData, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import services, { ServiceDTO } from "../../../pages/service/services";
import Header from "../components/header/MHeader";
import MFooter from "../components/footer/MFooter";

export default () => {

    const params = useLoaderData()

    const getService = () => {
        return services[(params as any)['service']]
    }

    useEffect(() => {
        console.log("params: ", params)
        document.scrollingElement?.scrollTo({top: 0, behavior: "smooth"})
    }, [params])

    return (
        <div className={styles['homepage']}>
            <Header activateIdx={1}/>
            <Welcome service={getService()}/>
            <Introduce service={getService()}/>
            <CreateYourAccount/>
            <MFooter/>
        </div>
    )

}


const Welcome = (props: {service: ServiceDTO}) => {

    const {
        service
    } = props
    return (
        <div className={styles['welcome__p1']}>
            {/* <img src={serviceBg1} className={styles['welcome__p1__bg']}/> */}
            <div className={styles['welcome__p1__box']}>
                <div className={styles['welcome__p1__label']}>
                Service
                </div>
                <div className={styles['welcome__p1__title']}>
                    {service.title}
                </div>
                
            </div>
        </div>
    )

}


const Introduce = (props: {service: ServiceDTO}) => {

    const {
        service
    } = props

    return (
        <div className={styles["introduce"]}>
            <div className={styles['introduce__title__main']}>{service.title}</div>
            <div className={styles['introduce__title__content']}>{service.content}</div>
            <img className={styles['introduce__bg']} src={serviceBg2}></img>
        </div>
    )
}


const CreateYourAccount = () => {

    return (
        <div className={styles['cya']}>
            <div className={styles['cya__title']}>Start your immigration journey with our experts today!</div>
            <div className={styles['cya__action']}><a href="mailto: jenny.liu@excelluslaw.com" className={styles['cya__action__a']}>Schedule A Consultation</a></div>
        </div>
    )
}

